import { useInfiniteQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { get } from "@/lib/api";
import { GridStory, Reveal } from "@/components/site/Stories";
import { useTexts } from "@/lib/layout";

export const useArticleFeed = (key, params) =>
  useInfiniteQuery({
    queryKey: ["feed", key, params],
    queryFn: ({ pageParam }) => get("/public/articles", { ...params, page: pageParam, limit: 12 }),
    initialPageParam: 1,
    getNextPageParam: (last) => (last.page < last.pages ? last.page + 1 : undefined),
  });

export const StoryFeed = ({ feed, empty = "No hay noticias todavía." }) => {
  const t = useTexts("layout");
  const items = feed.data?.pages.flatMap((p) => p.items) || [];
  if (feed.isLoading)
    return <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 animate-pulse">{[0, 1, 2].map((i) => <div key={i} className="aspect-[3/2] bg-muted" />)}</div>;
  if (!items.length) return <p className="text-lg text-muted-foreground py-10" data-testid="feed-empty">{empty}</p>;
  return (
    <>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" data-testid="story-feed">
        {items.map((a, i) => (
          <Reveal key={a.id} delay={(i % 3) * 0.06}><GridStory a={a} testid={`feed-story-${i}`} /></Reveal>
        ))}
      </div>
      {feed.hasNextPage && (
        <div className="mt-14 flex justify-center">
          <button
            onClick={() => feed.fetchNextPage()}
            disabled={feed.isFetchingNextPage}
            className="kicker border-2 border-foreground px-8 py-3.5 hover:bg-foreground hover:text-background transition-colors flex items-center gap-2"
            data-testid="feed-load-more-btn"
          >
            {feed.isFetchingNextPage && <Loader2 className="h-4 w-4 animate-spin" />}
            {t.load_more}
          </button>
        </div>
      )}
    </>
  );
};
